export default {
	EMPTY_DATA_TEXT:'没有数据',
	EMPTY_FILTER_DATA_TEXT:'没有符合条件的数据'
}


// WEBPACK FOOTER //
// ./src/config/params.js